import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { DateUtils } from '../utils/date.utils';
import { MathUtils } from '../utils/math.utils';
import { AddressUtils } from '../utils/address.utils';

const japanPattern: string = '\u3041-\u3096\u30A0-\u30FF\u3400-\u4DB5\u4E00-\u9FCB\uF900-\uFA6A\uFF5F-\uFF9F\u31F0-\u31FF\u3220-\u3243\u3280-\u337F\uFF01-\uFF5E';
const lettersPattern: string = `a-zA-Z\u00C0-\u017e${japanPattern}\\s-`;

export const streetAndNumberRegex: string = `^(?! +$)[0-9${lettersPattern}/.]+$`;

export const zipCodeRegex: string = `^(?! +$)[0-9${lettersPattern}]+$`;
export const canadaZipCodeRegex: string = `^[A-Z][0-9][A-Z] [0-9][A-Z][0-9]$`;
export const puertoRicoZipCodeRegex: RegExp = /^00\d{3}(-\d{4})?$/;

export const puertoRicoState: string = 'PR';

export const onlyLetters: ValidatorFn = Validators.pattern(`^(?! +$)[${lettersPattern}]+$`);
export const phonePattern: ValidatorFn = Validators.pattern(/^(?! )(?=(?:[^()]*\([^()]+\))*[^()]*$)[\d+\-()\s]+(?<! )$/);
export const cityStatePattern: ValidatorFn = Validators.pattern(`^(?! +$)[${lettersPattern}]+$`);
export const streetAndNumberPattern: ValidatorFn = Validators.pattern(streetAndNumberRegex);
export const noEmptySpaceOnTheBeginning: ValidatorFn = Validators.pattern((/^(?! +$)/));
export const noEmptySpace: ValidatorFn = Validators.pattern((/^\w+( +\w+)*$/));
export const uppercase: ValidatorFn = Validators.pattern(`^[A-Z][A-Z]`);

export function contractDurationLessThanEndOfSupportDate(contractStartDate: string, endOfSupport: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!endOfSupport) {
      return null;
    }

    const dateContractStartDate: Date = new Date(contractStartDate);
    const dateEndOfSupport: Date = new Date(endOfSupport);
    const contractEndDate: Date = new Date(dateContractStartDate.setFullYear(dateContractStartDate.getFullYear() + +control.value));
    const dateDifference: number = dateEndOfSupport.getTime() - contractEndDate.getTime();
    return dateDifference >= 0
      ? null : {wrongTerm: control.value};
  };
}

export function addressValidation(address: any): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!address) {
      return null;
    }
    if (!address.address1 || !address.city || !address.state || !address.zipCode) {
      return {
        addressValidation: control.value,
      };
    }
    return null;
  };
}

export function contractDateValidation(contractStartDate: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (DateUtils.countDaysFromToday(contractStartDate) < 8) {
      return {contractDateValidation: control.value};
    }
    return null;
  };
}

export function valueHasAtLeastOneLetter(abstractControl: AbstractControl): ValidationErrors | null {
  if (MathUtils.checkIfNumeric(abstractControl.value)) {
    return {valueHasAtLeastOneLetter: abstractControl.value};
  }
  return null;
}

export function zipCodeValidation(regex: RegExp, validatorName: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }

    if (!regex.test(control.value)) {
      return {[validatorName]: control.value};
    }

    return null;
  };
}

export function phoneHasLessThanGivenDigits(minLength: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }

    if (AddressUtils.formatPhone(control.value).length < minLength) {
      return {phoneHasLessThanGivenDigits: control.value};
    }

    return null;
  };
}
